<template>
  <transition name="fade-modal" mode="out-in">
    <div class="overlay" v-if="show" @click.self="$emit('close')">
      <div class="obox" :class="boxClasses">
        <slot/>
      </div>
    </div>
  </transition>
</template>


<script>
export default {
  name:"Modal",
  props:{
    boxClasses:{
      type:[ String, Array],
      required: false,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>


<style lang="scss">
  .overlay {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.7);
}
.obox {
  display: block;
  max-height: calc(100vh - 210px);
  overflow-y: auto;
  background: #fff;
  padding: 10px;
  width: 100%;
  max-width: 320px;
  box-shadow: 0 2px 4px -2px rgba(0,0,0,0.6);
  border-radius: 10px;
  h3 { margin: 10px; }
}


//Transitions

.fade-modal-enter-active, .fade-modal-leave-active {
  transition: all 500ms;

  .obox{
    transition: all 500ms 250ms;
  }
}
.fade-modal-leave-active {
  transition: all 500ms 250ms;

  .obox{
    transition: all 500ms;
  }
}
.fade-modal-enter{
  opacity: 0;

  .obox{
    opacity: 0;
    transform: translateY(40px);
  }
}

.fade-modal-leave-to {
  opacity: 0;

  .obox{
    transform: translateY(40px);
  }
}
</style>